import React from 'react';
import { BsPinFill } from "react-icons/bs";

export const PinIcon = (props: React.SVGProps<SVGSVGElement>) => {
    const Icon = BsPinFill as any
    
    return <Icon {...props} />;
}
